import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { ColorIcon } from "../../ColorIcon";
import { colorStateToHexString } from "../../ColorPicker";
import { getNewValueFromSelection } from "./RichTextFieldCustomToolbar";
export const TextColorPicker = ({ colorType, quillRef, currentValueRef }) => {
    const [color, setColor] = useState(colorType.defaultColor);
    const selectionRef = useRef();
    useEffect(() => {
        quillRef.current.getEditor().on("selection-change", (range) => {
            if (quillRef.current && range && !selectionRef.current) {
                const newValue = getNewValueFromSelection(range, colorType.quillFormat, quillRef) || color;
                setColor(newValue);
                if (currentValueRef) {
                    currentValueRef.current = newValue;
                }
            }
        });
    }, []);
    const handleColorChange = (color) => {
        const colorHexStr = colorStateToHexString(color);
        quillRef === null || quillRef === void 0 ? void 0 : quillRef.current.getEditor().formatText(selectionRef.current, colorType.quillFormat, colorHexStr, "user");
        setColor(colorHexStr);
        if (currentValueRef) {
            currentValueRef.current = colorHexStr;
        }
    };
    const onClosedCallback = () => {
        setTimeout(() => {
            if (!selectionRef.current.length) {
                quillRef === null || quillRef === void 0 ? void 0 : quillRef.current.getEditor().format(colorType.quillFormat, color, "user");
            }
            else {
                quillRef === null || quillRef === void 0 ? void 0 : quillRef.current.editor.focus();
            }
            selectionRef.current = undefined;
        });
    };
    const onOpenCallback = () => {
        selectionRef.current = quillRef === null || quillRef === void 0 ? void 0 : quillRef.current.getEditor().getSelection();
    };
    return _jsx(ColorIcon, { iconColor: "default", tooltip: colorType.type === "text" ? "Text color" : "Text background color", value: { color: color }, colorIconType: colorType.type, colorPickerTitle: "Color Picker", onColorChange: handleColorChange, enableTransparency: true, enableNoFill: true, predefinedColors: { title: "Brand Colors", colors: colorType.predefinedColors }, onOpenCallback: onOpenCallback, onClosedCallback: onClosedCallback });
};
//# sourceMappingURL=TextColorPicker.js.map